import { m as motion } from "framer-motion";
import { img, srcSet } from "@/data/site";

const EASE = [0.16, 1, 0.3, 1];

// Scroll reveal: content stays readable (starts partially visible) and animates in once.
export const Reveal = ({ children, className, delay = 0, y = 28, as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.2, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </M>
  );
};

// Masked line-by-line headline reveal.
export const MaskLines = ({ lines, className, delay = 0.1, as = "h1", testId }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className="block"
            initial={{ y: "105%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.75, delay: delay + i * 0.08, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Img = ({ id, alt, sizes = "100vw", className = "", priority = false, w = 1200, width = 1600, height = 1067 }) => (
  <img
    src={img(id, w)}
    srcSet={srcSet(id)}
    sizes={sizes}
    alt={alt}
    width={width}
    height={height}
    loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"}
    decoding="async"
    className={className}
  />
);

export const Planks = ({ className = "" }) => (
  <svg viewBox="0 0 120 22" className={className} aria-hidden="true">
    <path d="M0 22 L26 0 H44 L20 22 Z M24 22 L46 0 H64 L44 22 Z M48 22 L66 0 H120 L112 22 Z" fill="#F2C200" />
  </svg>
);
